import { render } from "./VideoGlow.vue?vue&type=template&id=13556936&scoped=true&bindings={\"src\":\"props\",\"blur\":\"props\",\"opacity\":\"props\",\"autoplay\":\"props\",\"muted\":\"props\",\"loop\":\"props\",\"playsinline\":\"props\",\"isMuted\":\"data\",\"glowStyle\":\"options\",\"isPostal2\":\"options\",\"isTowerCity\":\"options\",\"syncVideos\":\"options\",\"toggleMute\":\"options\",\"openVideoSource\":\"options\"}"
import script from "./VideoGlow.vue?vue&type=script&lang=js"
export * from "./VideoGlow.vue?vue&type=script&lang=js"

import "./VideoGlow.vue?vue&type=style&index=0&id=13556936&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13556936"

export default script